module.exports = __webpack_public_path__ + "img/banner.6df0a8c1.png";